const WIDGET_XML_TEMPLATE: string = `<widget>
	<previews>
		<preview width="320" height="240" style_bg_color="0xeee" />
	</previews>

	<api>
		<!-- Add your API here. For example 
		<prop name="prop1" type="int" default="0" help="What is this property?"/>
		-->
	</api>

	<styles>
		<style name="style_base" bg_opa="100%" bg_color="0x6080e0"/>
	</styles>

	<view extends="lv_obj">
		<style name="style_base" />

		<!-- Add widgets/components here -->

	</view>
</widget>
`;

export default WIDGET_XML_TEMPLATE;
